import { Loading } from "@msuite/ui/loading-screen";
import { useTranslation } from "@msuite/ui/localization";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { guardString } from "@msuite/utils/strings";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";
import { SubstitutionGeneralSummaryItem } from "./substitution-general-summary-item";

/** Props Interface */
interface SubstitutionGeneralSummaryProps {
	absenceId: string;
}

export function SubstitutionGeneralSummary({ absenceId }: SubstitutionGeneralSummaryProps) {
	/** Context */
	const { t } = useTranslation();

	/** Hooks */
	const auth = useAuth();

	/** Query */
	const { data, isFetching } = useQuery({
		queryKey: ["substitution-plan", absenceId],
		queryFn: async () => {
			const response = await client.users[":userId"].substitutions[":absenceId"].summary.$get({
				param: {
					userId: guardString(auth.user?.id),
					absenceId,
				},
			});
			const data = await responseHandler(response);
			return data.summary;
		},
		staleTime: 0,
	});

	/** Computed */
	const items = guardArray(data?.items);

	/** Render */
	return (
		<Loading isLoading={isFetching}>
			{items.length ? (
				<div className="v-stack gap-0 divide-y-[0.5px] *:border-color">
					{items.map((item) => (
						<SubstitutionGeneralSummaryItem
							key={`${item.projectNumber}-${item.projectName}`}
							item={item}
						/>
					))}
				</div>
			) : (
				<p className="label">{t("general.no_data_available")}</p>
			)}
		</Loading>
	);
}
